import React from 'react';
import logo from '../../assets/images/logo.png';
import { Link } from "react-router-dom";

const SidebarLogo = () => {
    return (
        <div className="sidebar-logo d-flex justify-content-between mb-5" style={{maxWidth:'200px'}}>
            <Link to='/'><img src={logo} alt=""/></Link>
        </div>
    )
};

export default SidebarLogo;
